<template>
  <div class="flex items-center justify-start laptop:w-1/12 h-full w-1/2">
    <a 
      href="https://courdescomptes.bj"
      class="cursor-pointer block"
    >
      <Image v-bind="currentLogoProps" />
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Image from '@/components/atoms/image/Image.vue'
import { DEFAULT_LOGO_PROPS } from '../constants/navigation'

interface Props {
  logoProps?: any
}

const props = defineProps<Props>()

const currentLogoProps = computed(() => props.logoProps || DEFAULT_LOGO_PROPS)
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

